<template>
  <div>
    <feather-icon
      icon="CheckCircleIcon"
      title="Onaylama"
      svgClasses="h-5 mr-5 hover:text-danger cursor-pointer"
      @click="
        getAccountMovementDetail();
        popupAccountTransaction = true;
      "
      v-if="1 == 1"
    />
    <!-- <feather-icon icon="SearchIcon" title="Detay" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="popupAccountTransaction = true" /> -->
    <!-- <feather-icon icon="Trash2Icon" title="Silme" svgClasses="h-5 w-5 mr-5  hover:text-danger cursor-pointer" @click="visible = true" v-if="editDeleteAvailable()" /> -->

    <!-- <vs-prompt :title= :active.sync="popupAccountTransaction"> -->
    <vs-prompt
      :vs-title="'#' + params.data.accountMovementId + ' hareket Id | ' + ' Durum ( ' + params.data.statusDescription + ' )'"
      vs-accept-text="Muhasebeleştir"
      vs-cancel-text="Kapat"
      vs-button-cancel="border"
      :vs-active.sync="popupAccountTransaction"
      :vs-buttons-hidden="($store.state.userData.authorizationList.find((f) => f.authorizationId == '14') == null && accountMovementList[0].movementType != 'Sale') || accountMovementList[0].status == 'M'"
      @vs-accept="createTransaction()"
    >
      <div class="vx-row w-full" style="margin-bottom: 39px;justify-content: left;font-size: large;">
        <label>
          Fiş Bilgileri :
          <!-- <Blink > -->
          <span style="color:#778899; font-weight:bold">
            {{ accountMovementList[0].transactionDescription }}
          </span>
          <!-- </Blink> -->
        </label>
      </div>

      <div class="vx-row" style="flex-flow: nowrap;width: max-content;">
        <div class="vx-col">
          <div class="vx-row">
            <div class="vx-col">
              <div class="vx-row" style="justify-content: center;">
                <label> BORÇLU HESAP BİLGİLERİ</label>
                <vs-divider style="flex-flow: wrap;" />
              </div>
              <div class="vx-row">
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Hesap No</label>
                </div>
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Hesap Bilgileri</label>
                </div>
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Bakiye</label>
                </div>
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Fiş Tutarı</label>
                </div>
              </div>

              <div :key="i" v-for="(tr, i) in accountMovementList[0].owedAccountList">
                <div class="vx-row">
                  <div class="vx-col md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" v-model="tr.accountId" placeholder="Hesap No" />
                    <a :href="tr.accountLink" style="margin-top: -2px;" target="blank">Hesap Link</a>
                  </div>
                  <div class="vx-col md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" v-model="tr.accountDescription" placeholder="Hesap Bilgileri" />
                  </div>
                  <div class="vx-col md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" v-model="tr.balance" placeholder="Bakiye" />
                  </div>
                  <div class="vx-col md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" type="number" v-model="tr.transactionAmount" placeholder="Fiş Tutarı" />
                  </div>
                </div>
              </div>
              <div class="vx-col w-full" style="display:flex;justify-content:flex-end;margin-top:10px">
                <label style="margin-top:11px;margin-right:5px;font-weight:bold">Borç Ayağı Toplamı</label>
                <vs-input
                  style="margin-right: -11px;"
                  readonly="readonly"
                  :value="
                    accountMovementList[0].owedAccountList
                      .reduce((acc, ele) => {
                        return acc + parseFloat(ele.transactionAmount);
                      }, 0)
                      .toFixed(2)
                  "
                  type="number"
                  placeholder="Borç Ayağı Toplamı"
                />
              </div>
            </div>
          </div>
        </div>
        <div style="border: solid;margin-top:26px"></div>
        <div class="vx-col">
          <div class="vx-row">
            <div class="vx-col">
              <div class="vx-row" style="justify-content: center;">
                <label> ALACAKLI HESAP BİLGİLERİ</label>
                <vs-divider style="flex-flow: wrap;" />
              </div>

              <div class="vx-row">
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Hesap No</label>
                </div>
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Hesap Bilgileri</label>
                </div>
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Bakiye</label>
                </div>
                <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                  <label> Fiş Tutarı</label>
                </div>
              </div>
              <div :key="i" v-for="(tr, i) in accountMovementList[0].owedToAccountList">
                <div class="vx-row">
                  <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" v-model="tr.accountId" placeholder="Hesap No" />
                    <a :href="tr.accountLink" style="margin-top: -2px;" target="blank">Hesap Link</a>
                  </div>
                  <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" v-model="tr.accountDescription" placeholder="Hesap Bilgileri" />
                  </div>
                  <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input readonly="readonly" v-model="tr.balance" placeholder="Bakiye" />
                  </div>
                  <div class="vx-col  md:w-1/4 w-full" style="display:grid;padding:0;">
                    <vs-input v-model="tr.transactionAmount" type="number" placeholder="Fiş Tutarı" />
                  </div>
                </div>
              </div>
              <div class="vx-col   w-full" style="display:flex;justify-content:flex-end;margin-top:10px">
                <label style="margin-top:11px;margin-right:15px;font-weight:bold">Alacak Ayağı Toplamı</label>
                <vs-input
                  style="margin-right:-11px"
                  readonly="readonly"
                  :value="
                    accountMovementList[0].owedToAccountList
                      .reduce((acc, ele) => {
                        return acc + parseFloat(ele.transactionAmount);
                      }, 0)
                      .toFixed(2)
                  "
                  type="number"
                  placeholder="Alacak Ayağı Toplamı"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import Blink from "vue-blink";

export default {
  components: { Blink },
  created: async function() {},
  data() {
    return {
      visible: false,
      popupOwnCost: false,
      visibleForApprove: false,
      displayEdit: false,
      popupAccountTransaction: false,
      accountMovementList: [{ owedAccountList: [], owedToAccountList: [] }],
    };
  },
  name: "CellRendererActions",
  methods: {
    getAccountMovementDetail: async function() {
      if (this.params.data.status == "B") {
        this.accountMovementList = await repository.postEntity("Accounting/GetAccountMovementDetailForTransaction", { movementType: this.params.data.movementType, accountMovementId: this.params.data.accountMovementId }).then((r) => r.list);
      } else {
        this.accountMovementList = await repository.postEntity("Accounting/GetTransactedAccountMovementDetail", { movementType: this.params.data.movementType, accountMovementId: this.params.data.accountMovementId }).then((r) => r.list);
      }
      console.log(this.accountMovementList);
    },

    createTransaction: async function() {
      if ((await this.checkTransactionAmount()) == false) {
        return;
      } else {
        let resultConfirm = await this.$swal.fire({
          icon: "warning",
          title: "Devam etmek istediğinize emin misiniz?",
          // text: "Devam etmek istediğinize emin misiniz?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });

        if (resultConfirm.isConfirmed) {
          console.log(this.accountMovementList[0]);

          await repository.postEntity("Accounting/CreateAccountTransaction", this.accountMovementList[0]);

          await this.$swal.fire({ icon: "success", title: "Muhasebeleştirme başarılı." });
        }
      }
    },

    checkTransactionAmount: async function() {
      let sumOwedToTransactionAmount = this.accountMovementList[0].owedToAccountList
        .reduce((acc, ele) => {
          ele.transactionAmount = parseFloat(ele.transactionAmount).toFixed(2);
          return acc + parseFloat(ele.transactionAmount);
        }, 0)
        .toFixed(2);

      if (this.accountMovementList[0].amount != sumOwedToTransactionAmount || this.accountMovementList[0].owedToAccountList.every((p) => p.transactionAmount >= 0) == false) {
        this.popupAccountTransaction = true;

        await this.$swal.fire({
          icon: "error",
          text: "Balans Hatası. Fiş bacaklarının toplamı birbirine eşit değildir. Fiş bacaklarındaki tutarlar negatif olmamalıdır. Virgülden sonra 2 hane olmalıdır.",
        });

        return false;
      }
    },

    approveAvailable() {
      if (this.params.data.status == "T" && this.params.data.formOwnerId != this.$store.state.userData.userId) {
        return true;
      } else {
        return false;
      }
    },
  },

  computed: {},
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.popupAccountTransaction = false;
      }
    });
  },
};
</script>

<style lang="scss">
.vs-dialog {
  max-width: 1610px !important;
  max-height: 95% !important;
}
</style>
